import {
  map as _map,
  sum as _sum,
  toNumber as _toNumber,
  toArray as _toArray,
  filter as _filter,
  groupBy as _groupBy,
} from 'lodash';
import {
  SET_NOTIFICATIONS,
  CLEAR_LOST_NOTIFICATION,
  CLEAR_ACCEPTED_NOTIFICATION,
  SET_NOTIFICATION_POLL_TIME,
} from '../constants/AppConstants';

const initialState = {
  pollTime: 0,
  lastRequestTime: 0,
  added: [],
  updated: [],
  lost: [],
  accepted: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_NOTIFICATION_POLL_TIME: {
      const { pollTime, lastRequestTime } = action.payload;
      return {
        ...state,
        pollTime,
        lastRequestTime
      }
    }
    case SET_NOTIFICATIONS: {
      const { added: eAdded, updated: eUpdated, lost: eLost, accepted: eAccepted } = state;
      const { added: nAdded, updated: nUpdated, lost: nLost, accepted: nAccepted } = action.payload;
      const calculateSum = (e, a) => {
        const grouped = _groupBy([...e, ...a], 'serviceID');
        return _map(_toArray(grouped), (group) => {
          const count = _sum(_map(group, g => _toNumber(g.count)));
          const { serviceID } = group[0];
          return { serviceID, count }
        });
      }
      const added = calculateSum(eAdded, nAdded);
      const updated = calculateSum(eUpdated, nUpdated);
      const lost = calculateSum(eLost, nLost);
      const accepted = calculateSum(eAccepted, nAccepted);
      return {
        ...state,
        added,
        updated,
        lost,
        accepted,
      }
    }
    case CLEAR_LOST_NOTIFICATION: {
      const { added: eAdded, updated: eUpdated, lost: eLost } = state;
      const { serviceID } = action.payload;
      const clearLostNotification = (notifications) => {
        return _filter(notifications, n => n.serviceID != serviceID);
      }
      const added = clearLostNotification(eAdded);
      const updated = clearLostNotification(eUpdated);
      const lost = clearLostNotification(eLost);
      return {
        ...state,
        added,
        updated,
        lost,
      }
    }
    case CLEAR_ACCEPTED_NOTIFICATION: {
      const { accepted: eAccepted } = state;
      const { serviceID } = action.payload;
      const clearLostNotification = (notifications) => {
        return _filter(notifications, n => n.serviceID != serviceID);
      }
      const accepted = clearLostNotification(eAccepted);
      return {
        ...state,
        accepted,
      }
    }
    default: {
      return state;
    }
  }
};
